import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Alert, Box, Button, Chip, IconButton, Paper, Snackbar } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import SelectBoxSearch from "src/shared/components/select_box_search";
import { typeTaskMock } from "src/shared/mocks/task";
import { ErrorComponent } from "src/shared/pages/error";
import Tasks from "./components/tasks/tasks";
import { useNavigate } from "react-router-dom";
import { PlanningState, useDispatch } from "src/stateManagement/redux";
import { loadAllTasks } from "src/stateManagement/redux/slices/planificacion/asynReducer";
import { PlanningTask } from "src/stateManagement/redux/slices/planificacion/interfaces";
import { useSelector } from "react-redux";
import InventoryIcon from '@mui/icons-material/Inventory';
import ViewListIcon from '@mui/icons-material/ViewList';
import { useLocation } from "react-router-dom";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ padding: "15px 0px" }}>{children}</Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const internalTabs = [
    { "name": "activies", "states": ['pending', 'inProgress', 'analyzing', 'completed'], icon: <ViewListIcon /> },
    { "name": "archieves", "states": ['discarded', 'blocked'], icon: <InventoryIcon /> },
]

export const Planning = () => {

    const dispatch = useDispatch();

    const location = useLocation();

    const { planingTask } = useSelector(PlanningState);

    const [value, setValue] = useState(0);
    const options: string[] = ["Nombre", "Asignado"];
    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [inputValueFilter, setInputValueFilter] = useState<string>("");
    const [tasks, setTasks] = useState<PlanningTask[]>([]);
    const [filteredTaks, setfilteredTaks] = useState<PlanningTask[]>([])
    const [typeTask, setTypeTask] = useState(typeTaskMock);

    const [infoAlert, setInfoAlert] = useState({
        open: false,
        message: "",
    })

    const [activeSummaryView, setactiveSummaryView] = useState(internalTabs[0]);

    const navigate = useNavigate();

    useEffect(() => {
        if (planingTask.length === 0) {
            dispatch(loadAllTasks(
                undefined,
                undefined,
                undefined,
                undefined,
            ));
        }
    }, []);


    useEffect(() => {

        let allTask = planingTask;

        if (inputValueFilter && selectedOption === "Nombre") {
            allTask = allTask.filter(x =>
                x.asignedGroup.toLocaleLowerCase().includes(inputValueFilter?.toLowerCase())
                || x.tecnology?.toLowerCase().includes(inputValueFilter?.toLowerCase()) || x.title?.toLowerCase().includes(inputValueFilter?.toLowerCase()));
        } else if (inputValueFilter && selectedOption === "Asignado") {
            allTask = allTask.filter(x =>
                x.asignedUserName.toLocaleLowerCase().includes(inputValueFilter?.toLowerCase()));
        }

        if (Array.isArray(allTask)) {
            setTasks(allTask);
        }


    }, [planingTask, inputValueFilter]);

    useEffect(() => {
        if (location?.state?.from) {
            if (location.state.from === "taskdeleted") {
                setInfoAlert({ open: true, message: "Tarea borrada" })
                dispatch(loadAllTasks(
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                ));
            }

            if (location.state.from === "taskupdated") {
                setInfoAlert({ open: true, message: "Tarea guardada" })
                dispatch(loadAllTasks(
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                ));
            }


            navigate(location.pathname, { replace: true, state: {} });


        }
    }, [location.state])


    const handleSelectChange = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        setSelectedOption(event.target.value);
        setInputValueFilter("");
    };

    const handleFilterInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValueFilter(event.target.value);
    };

    const onClickChangeSummaryView = (tab: any) => {
        setactiveSummaryView(tab)
    }

    // return (
    //     <ErrorComponent
    //     type="403"
    //     infoPage="Moodulo No Disponible"
    // />
    // )

    return (
        <Box sx={{ width: "100%" }}>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={infoAlert?.open}
                onClose={() => setInfoAlert({ open: false, message: "" })}
                autoHideDuration={6000}
            >
                <Alert
                    onClose={() => setInfoAlert({ open: false, message: "" })}
                    severity="success"
                    variant="filled"
                >
                    {infoAlert?.message}
                </Alert>
            </Snackbar>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Box sx={{ width: "100%" }}>
                        <CustomTabPanel value={value} index={0}>
                            <Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <SelectBoxSearch
                                        options={options}
                                        selectedOption={selectedOption}
                                        onOptionChangeSelectBox={
                                            handleSelectChange
                                        }
                                        onValueChangeInput={handleFilterInput}
                                        inputValue={inputValueFilter}
                                    />
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        startIcon={<ControlPointOutlinedIcon />}
                                        onClick={() => navigate("/gto/task/info/0")}
                                    >
                                        Agregar tarea
                                    </Button>
                                </Box>

                                <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 3, gap: 2 }}>
                                    {
                                        internalTabs.map((item, index) => {
                                            return (
                                                <IconButton
                                                    onClick={() => onClickChangeSummaryView(item)}
                                                    key={index}
                                                    className="active_button"
                                                    sx={{
                                                        backgroundColor: activeSummaryView.name === item.name ? "#1976d2" : "#f0f0f0",
                                                        color: activeSummaryView.name === item.name ? "#fff" : "#000",
                                                        "&:hover": {
                                                            backgroundColor: activeSummaryView.name === item.name ? "#42a5f5" : "#f0f0f0",
                                                        },
                                                    }}
                                                >
                                                    {item.icon}
                                                </IconButton>
                                            )
                                        })
                                    }
                                </Box>

                                <Grid container spacing={2} sx={{ mt: 4, overflow: "scroll", display: "flex" }}>
                                    {typeTask.filter(x => activeSummaryView.states.includes(x.status)).map((type, index) => (
                                        <Grid size={3} key={index}>
                                            <Paper
                                                sx={{
                                                    backgroundColor: type.bgColor,
                                                    border: "1px solid grey",
                                                    borderRadius: "5px",
                                                    padding: "7px",
                                                    height: "80vh",
                                                }}
                                            >
                                                <Chip
                                                    sx={{
                                                        backgroundColor:
                                                            type.chipColor,
                                                        color: type.textColor,
                                                    }}
                                                    icon={
                                                        <RadioButtonUncheckedIcon
                                                            sx={{
                                                                color: `${type.iconColor}!important`,
                                                            }}
                                                        />
                                                    }
                                                    label={type.title}
                                                />
                                                <Grid size={12} sx={{ height: "70vh", overflowY: "auto", mt: 1 }}>
                                                    {tasks?.filter(x => x.status === type.status)?.map(
                                                        (task, index) => (
                                                            <Tasks task={task} key={index}
                                                            />
                                                        )
                                                    )}
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <ErrorComponent
                                type="403"
                                infoPage="Módulo No Disponible"
                            />
                        </CustomTabPanel>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Planning;
